
const studentandclasstype = {
    state: {
       addStudentAndClassTypeDialog: {
          title:'新增学员可选班级类型信息',
          type:'add'
       },
       studentAndClassTypeSearch: {
          stdId:'',
          stdName:''
       },
       studentAndClassTypeSearchBtnDisabled: true
    },
    getters:{
      addStudentAndClassTypeDialog: state => state.addStudentAndClassTypeDialog,
      studentAndClassTypeSearch: state => state.studentAndClassTypeSearch,
      studentAndClassTypeSearchBtnDisabled: state => state.studentAndClassTypeSearchBtnDisabled
    },
    mutations: {
      SET_STUDENTANDCLASSTYPE_DIALOG_TITLE: (state, type) => {
        if(type === 'add'){
          state.addStudentAndClassTypeDialog.title = '新增学员可选班级类型信息'
          state.addStudentAndClassTypeDialog.type = 'add'
        }else{
          state.addStudentAndClassTypeDialog.title = '编辑学员可选班级类型信息'
          state.addStudentAndClassTypeDialog.type = 'edit'
        }
      },
      SET_STUDENTANDCLASSTYPE_SEARCH : (state, payload) => {
         state.studentAndClassTypeSearch = payload;
         console.log("studentAndClassTypeSearch"+state.studentAndClassTypeSearch);
      },
      SET_STUDENTANDCLASSTYPE_SEARCHBTN_DISABLED : (state, payload) => {
        state.studentAndClassTypeSearchBtnDisabled = payload;
      }
    },
    actions: {
       
    }
  }
  
  export default studentandclasstype
  